import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToolbar } from '@ionic/react'
import { chevronBackOutline } from 'ionicons/icons'
import React, { BaseSyntheticEvent } from 'react'
import PCRHeader from '../../pcrHeader/PCRHeader.component'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import TextArea from '../../textArea/TextArea.component'
import { useDispatch, useSelector } from 'react-redux'
import { resetCommentsState, setCommentText, setHideComments } from '../store/comments.actions'
import { getComments } from '../selectors'
import { makeActionCreator } from '../../../utilities'
import { goBack } from '../../../utilities/navigation.util'

const CommentsPage: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const {
    commentPageTitle,
    commentText,
    commentMaxLength,
    previousPagePath,
    onChangeAction,
    saveAction,
    hideComments,
  } = useSelector(getComments)

  const onBackClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    if (previousPagePath) {
      history.replace(previousPagePath)
    } else {
      goBack()
    }
    dispatch(resetCommentsState())
  }

  const handleSave = () => {
    if (saveAction.length > 0) {
      const [actionType] = saveAction
      const saveActionCreator = makeActionCreator(actionType)
      dispatch(saveActionCreator())
    }
  }

  const saveOnClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    handleSave()
  }

  const handleOnChange = (e: CustomEvent) => {
    if (onChangeAction.length <= 0) return // added this to restrict this function call when user clicks on back
    const [actionType, payload] = onChangeAction
    const saveActionCreator = makeActionCreator(actionType, payload)
    dispatch(saveActionCreator(e.detail.value))
    dispatch(setCommentText(e.detail.value))
    dispatch(setHideComments(false))
    if (saveAction && saveAction.length > 0) {
      handleSave()
    }
  }

  return (
    <>
      <IonPage id='CommonCommentsPage'>
        <PCRHeader />
        <IonHeader>
          <IonToolbar className='toolbarBorder' color='light'>
            <IonButtons slot='start'>
              <IonButton data-testid='Back' color='primary-alt' onClick={onBackClick}>
                <IonIcon icon={chevronBackOutline} />
                {t('common.buttons.Back')}
              </IonButton>
            </IonButtons>
            <IonTitle data-testid='HeaderTitle'>{commentPageTitle}</IonTitle>
            <IonButtons slot='end'>
              <IonButton data-testid='Save' color='primary-alt' fill='clear' onClick={saveOnClick}>
                {t('common.buttons.Save')}
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent id='main-comments-page-content' color='light' fullscreen>
          <TextArea
            dataTestID={commentPageTitle}
            label={commentPageTitle}
            maxlength={commentMaxLength}
            value={!hideComments ? commentText : ''}
            validationId={'validationId'}
            onChangeAction={handleOnChange}
          />
        </IonContent>
      </IonPage>
    </>
  )
}

export default CommentsPage
